import { Button } from 'antd';
import { ButtonProps as AntButtonProps } from 'antd/es/button/button';
import styled from 'styled-components';

import { ButtonProps } from '@atom/button/button';
import { isExist } from '@util/data/is-exist';

type StyleButtonType = AntButtonProps & Pick<ButtonProps, 'capitalized'>;

export const AntButton = styled(Button)<StyleButtonType>`
  display: flex;
  justify-content: center;
  align-items: center;
  ${(props) => (props.block ? 'flex: 1;' : '')};

  padding: ${(props) => (isExist(props.icon) ? 7 : 10)}px 16px;
  border-radius: 0 8px 0 8px;
  border-width: 1px;
  height: auto;

  text-transform: ${(props) => (props.capitalized ? 'uppercase' : 'none')};

  &.ant-btn-sm {
    padding: 8px;
    height: auto;
    font-size: 12px;
    line-height: 14px;
    font-weight: 500;
    border-radius: 0 8px 0 8px;
  }

  &.ant-btn-disabled {
    opacity: 0.5;
  }
`;
